<script>
import {mapActions} from "vuex";
import _ from "lodash";

export default {
  name: "TheMeetingVoteCommentMenu",

  props: {
    sizeNegativeVote: {
      type: Number,
      required: true,
    },

    checkNegativeVote: {
      type: Boolean,
      required: true,
    },

    checkPositiveVote: {
      type: Boolean,
      required: true,
    },

    comment: {
      type: Object,
      required: true,
    },

    idReviewer: {
      type: Number,
      required: true,
    }

  },

  data() {
    return {
      menu: false,
      maxLengthComment: 300,
      voteCommentRules: [
        v => v.length <= this.maxLengthComment || 'Комментарий должен быть менее 300 символов',
      ],
      voteComment: "",
      loadingVote: false,
    };
  },


  methods: {
    ...mapActions({
      addVoteComment: 'scholarship_comment/addVoteComment',
      updateVoteComment: 'scholarship_comment/updateVoteComment',
    }),

    closeMenu() {
      this.menu = false;
      this.voteComment = "";
    },

    async voteBtnAction({status}) {
      this.loadingVote = true;

      if (this.checkPositiveVote || this.checkNegativeVote) {
        const vote = _.find(this.comment.comment_votes, vote => vote.person_id === this.idReviewer);
        await this.updateVoteComment({
          idComment: this.comment.id,
          idVote: vote.id,
          comment: this.voteComment,
        })
      }
      else {
        await this.addVoteComment({idComment: this.comment.id, status: status, comment: this.voteComment})
      }
      this.voteComment = "";
      this.menu = false;
      this.loadingVote = false;
    },
  },
}
</script>

<template>
  <v-menu
    top
    :close-on-click="false"
    :close-on-content-click="false"
    v-model="menu"
    content-class="rounded-xl"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        x-small
        v-bind="attrs"
        v-on="on"
        :loading="loadingVote"
        :disabled="checkNegativeVote"

        color="teal darken-3"
        class="white--text rounded-xl"
      >
        {{sizeNegativeVote}} <v-divider class="mx-2" vertical/> Против
      </v-btn>
    </template>

    <v-card width="550px" max-height="350px">
      <v-card-text>
        Опишите причину
      </v-card-text>
      <v-card-text class="rounded-xl py-0">
        <v-textarea
          v-model="voteComment"
          outlined
          class="rounded-xl"
          color="teal darken-3"
          :rules="voteCommentRules"
          :counter="maxLengthComment"
        >
        </v-textarea>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn small outlined color="error" class="rounded-xl" @click="closeMenu">
          Закрыть
        </v-btn>
        <v-btn
          @click="voteBtnAction({status: false})"
          small
          color="teal darken-3"
          class="rounded-xl white--text"
        >
          Отправить
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<style scoped>

</style>